module.exports = __webpack_public_path__ + "72b34c25f94f180e2f7e93ffd285a581.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/media/10/10.jpg
// module id = 568
// module chunks = 0